"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useWindowScrolling;

var _react = require("react");

function useWindowScrolling(callback, isListening) {
  var isTicking = (0, _react.useRef)(false);
  var listener = (0, _react.useCallback)(function (event) {
    if (!isTicking.current) {
      window.requestAnimationFrame(function () {
        callback(event);
        isTicking.current = false;
      });
      isTicking.current = true;
    }
  }, [callback]);
  (0, _react.useEffect)(function () {
    if (isListening) {
      window.addEventListener('scroll', listener);
      window.addEventListener('wheel', listener);
    }

    return function () {
      window.removeEventListener('scroll', listener);
      window.removeEventListener('wheel', listener);
    };
  }, [listener, isListening]);
}